import Cognito from './cognito';
import { CognitoSettings } from '@/lib/const';

// シングルトンインスタンス（router/index.js からインポートして使用される）
const cognito = new Cognito();
cognito.configure(CognitoSettings);

// Vue 3 プラグイン: main.js で app.use(CognitoPlugin) として使用
export const CognitoPlugin = {
  install(app) {
    app.config.globalProperties.$cognito = cognito;
  },
};

export default cognito;
